import React, { Component } from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";

import stl from "./train.module.scss";

class Train extends Component {
	state = {
		data: [],
	};

	componentDidMount() {
		const { LayoutActions } = this.props;
		LayoutActions.setModal({
			id: "trainModal",
			target: this,
		});
	}
	
	setData = (data) => {
		let list = [];
		const date = new Date();
		const now = date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate()) + appendZeroValue(date.getHours()) + "" + appendZeroValue(date.getMinutes());
		data.list.forEach((item) => {
			if (parseInt(now) < parseInt(item.depplandtime.substring(0, 12))) {
				list.push(item);
			}
		});

		data.list = list;
		this.setState({
			data,
		});
	}


	render() {

		const { data } = this.state;

		const contents = (
			<div className={stl.trainWrap}>
				<div className={stl.titleWrap}>
					<span className={stl.posLabel}>{`${data.selectDate} [ ${data.startStationName} → ${data.endStationName} ] `}</span>
					<span className="">조회결과</span>
				</div>

				<div className={stl.infoWrap}>※ 본 정보는 한국철도공사의 사정에 따라 변경될 수 있습니다. 최신정보 확인은 한국철도공사 홈페이지(<a href="https://letskorail.com" target="_blank">https://letskorail.com</a>)에서 확인하시기 바랍니다.</div>

				<div className={stl.contentsWrap}>
					<table>
						<caption>조회결과</caption>
						<thead>
							<tr>
								<th>열차종류</th>
								<th>출발시간</th>
								<th>도착시간</th>
								<th>운임료</th>
							</tr>
						</thead>
						<tbody>
						{	data.list !== undefined && data.list.length > 0 &&
								data.list.map((item, idx) => {

									const depTime = item.depplandtime.substring(8, 10) + ':'
												+ item.depplandtime.substring(10, 12);

									const arrTime = item.arrplandtime.substring(8, 10) + ':'
												+ item.arrplandtime.substring(10, 12);

									return (
										<tr key={idx}>
											<td>{`${item.traingradename}(${item.trainno})`}</td>
											<td>{depTime}</td>
											<td>{arrTime}</td>
											<td>{item.adultcharge !== null ? item.adultcharge.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-'}</td>
										</tr>
									);
								})
							}
							{
								data.list !== undefined && data.list.length === 0 &&
								<tr>
									<td colSpan="4">조회하신 정보가 존재하지 않습니다.</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		);

		return (
			<div>
				<SisModal id={this.props.id} className={stl.trainModal} title="KTX/열차 운행시간 조회" draggable contents={contents} />
			</div>
		);
	}
}

function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}


export default compose(
	withRouter,
	connect(
		(state) => ({
			layout: state.layout,
			sis: state.sisMap,
		}),
		(dispatch) => ({
			SisMapActions: bindActionCreators(sisMapActions, dispatch),
			LayoutActions: bindActionCreators(layoutActions, dispatch),
		})
	)
)(Train);

// export default Train;
